<template lang="pug">
.debug-login-admin
  .debug-login-admin__input-area
    .debug-login-admin__input-area__header ログイン
    .validate(v-if='errorMessages.length > 0')
      p.validate__message(v-for='errorMessage in errorMessages') {{ errorMessage }}
    .debug-login-admin__input-area__bcbt-code
      p BCBTコード
      input(v-model='bcbtCode')
    .debug-login-admin__input-area__password
      p パスワード
      input(type='password', v-model='password')
    a.debug-login-admin__input-area__button(@click='submitLogin') ログイン
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'

@Component
export default class DebugLoginAdmin extends Mixins(LoginMethods) {
  private bcbtCode = ''
  private password = ''

  private async submitLogin() {
    this.$loading.start()
    // 管理者権限ログイン
    await this.adminLogin(this.bcbtCode, this.password)
    this.$loading.complete()
  }

  /**
   * 遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/debug'
  }
}
</script>

<style lang="stylus" scoped>
.debug-login-admin
  margin 100px
  width 320px

  &__input-area
    margin-top 30px
</style>
